var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var Utils = require('../../utils/Utils');
var createReactClass = require('create-react-class');

var GtmLoad = createReactClass({
    componentDidMount: function () {
        var props = this.props;        
        Utils.setGADatalayer(props.countryCode, props.localeId, props.userType, props.realmId, props.clientId, props.redirectUrl || props.postLogoutRedirectUri);
    },

    render: function () {
        return (
            <div> </div>
        );
    }
});

module.exports = injectIntl(GtmLoad);
